export default __webpack_public_path__ + "static/media/edit_icon.37cfef15.svg";